import {Typography} from "@mui/material";

export const ProductInfoContent = () => {


    return {
        title: 'Products',
        content: (
            <>
                <Typography paragraph>
                    Products represent the films, television programs,
                    episodes, specials, and other intellectual property
                    that are subject to contractual obligations within
                    the system.
                </Typography>

                <ul>
                    <li>
                        Products are often referred to throughout the
                        system as <strong>Properties</strong>, because
                        in the context of contract administration they
                        represent intellectual property that is governed
                        by contractual obligations.
                    </li>

                    <li>
                        Products serve as the foundation for licenses,
                        usage, viewership, financial activity, subscriber
                        activity, and obligation calculations.
                    </li>

                    <li>
                        Products can be organized into series, seasons,
                        episodes, movies, specials, and other production
                        hierarchies.
                    </li>

                    <li>
                        Products may be designated as covered by one or
                        more union or guild agreements.
                    </li>

                    <li>
                        Guild contracts can be assigned directly from
                        the Product grid, allowing obligations to be
                        associated with the appropriate contractual
                        framework.
                    </li>

                    <li>
                        Use the <strong>Search</strong> (magnifying glass)
                        to locate existing Product records.
                    </li>

                    <li>
                        Use the <strong>Upload</strong> button to import
                        Product data from external files.
                    </li>

                    <li>
                        Use the <strong>Add</strong> (+) button to create
                        a new Product manually.
                    </li>

                    <li>
                        Use the row menu on the left side of the grid
                        to clone, edit, or delete Product records.
                    </li>

                    <li>
                        Maintaining accurate Product data is critical
                        because nearly all contractual, financial,
                        usage, and obligation processing ultimately
                        references a Product record.
                    </li>
                </ul>
            </>
        )
    };

};




